import { http } from '../utils/http'

const getCountAction = () => {
  const url = '/config/operation/getRecord'
  return http.post(url)
};
const saveCountAction = (params) => {
  const url = '/config/operation/saveRecord'
  return http.post(url, params)
};
const getIngestionAction = () => {
  // const url = '/open/api/v1/mapping-topic/dictionary/find'
  // return http.post(url, params)
  const url = `/config/customer/list`
  return http.post(url, {})
};

const getBusinessAction = (params) => {
  const url = '/monitor/dashboard/businessStatistics'
  return http.post(url, params)
};
const searchApiAction = (params) => {
  const url = '/config/dashboard/apiStatistics'
  return http.post(url, params)
};
const searchMessageAction = (params) => {
  const url = '/monitor/dashboard/messageStatistics'
  return http.post(url, params)
};
const searchMessageDistributionAction = (params) => {
  const url = '/monitor/dashboard/messageDistribution'
  return http.post(url, params)
};
const getApiShortName = (params) => {
  const url = '/config/apiConfigInfo/getApiConfigListByCustomerIds'
  return http.post(url, params)
};
export default {
  getCountAction,
  saveCountAction,
  getIngestionAction,
  getBusinessAction,
  searchApiAction,
  searchMessageAction,
  searchMessageDistributionAction,
  getApiShortName,
}
